import { LOCAL_STORAGE_IDS } from "constants/constants";
import { getCookie, setCookie } from "utils/commonMethods";

//Handles authentication controllers.
function useAuthentication() {
  const userIsLoggedIn = function () {
    return getCookie(LOCAL_STORAGE_IDS.USER_TOKEN);
  };

  const setUserToken = function ({ token, id }) {
    setCookie(LOCAL_STORAGE_IDS.USER_ID, id);
    return setCookie(LOCAL_STORAGE_IDS.USER_TOKEN, `Bearer ${token}`);
  };

  const getUserId = function () {
    return getCookie(LOCAL_STORAGE_IDS.USER_ID);
  };

  return { userIsLoggedIn, setUserToken, getUserId };
}

export default useAuthentication;
